import { useSpedFileSolicitation } from '@/core/domain/sped/sped-files/sped-files.hooks';
import { useSpedDocumentContext } from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button } from 'antd';

export default function SpedDocumentGenerateFiles() {
  const spedDocument = useSpedDocumentContext();

  const hasPermission = hasPermissions([
    Authorities.SPED_DOCUMENT_GENERATE_FILE,
  ]);

  const fileSolicitation = useSpedFileSolicitation();

  const consult = async () => {
    if (!spedDocument) return;

    await fileSolicitation.mutateAsync(spedDocument.id);
  };

  return (
    <Button
      type="primary"
      onClick={consult}
      loading={fileSolicitation.isLoading}
      disabled={!hasPermission}
    >
      {fileSolicitation.isLoading ? 'Solicitando...' : 'Solicitar arquivo'}
    </Button>
  );
}
